var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[(_vm.queryParameters.cssURL)?_c('link',{attrs:{"rel":"stylesheet","href":decodeURIComponent(_vm.queryParameters.cssURL)}}):_vm._e(),_c('queue-form',{attrs:{"pageType":'webview'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }